"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfNurseInviteCreateDto = instanceOfNurseInviteCreateDto;
exports.NurseInviteCreateDtoFromJSON = NurseInviteCreateDtoFromJSON;
exports.NurseInviteCreateDtoFromJSONTyped = NurseInviteCreateDtoFromJSONTyped;
exports.NurseInviteCreateDtoToJSON = NurseInviteCreateDtoToJSON;
exports.NurseInviteCreateDtoToJSONTyped = NurseInviteCreateDtoToJSONTyped;
/**
 * Check if a given object implements the NurseInviteCreateDto interface.
 */
function instanceOfNurseInviteCreateDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function NurseInviteCreateDtoFromJSON(json) {
    return NurseInviteCreateDtoFromJSONTyped(json, false);
}
function NurseInviteCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'inviterProfileId': json['inviterProfileId'] == null ? undefined : json['inviterProfileId'],
        'email': json['email'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}
function NurseInviteCreateDtoToJSON(json) {
    return NurseInviteCreateDtoToJSONTyped(json, false);
}
function NurseInviteCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'inviterProfileId': value['inviterProfileId'],
        'email': value['email'],
        'message': value['message'],
    };
}
//# sourceMappingURL=NurseInviteCreateDto.js.map